import { Column, Row, Typography } from '@tempmee/react';
import { SelectedDatePill } from './SelectedDatePill';

interface ISelectedDatesListProps {
  dates: Date[];
  onRemoveDate: (date: Date) => void;
}

export const SelectedDatesList = ({ dates, onRemoveDate }: ISelectedDatesListProps) => {
  const sortedDates = [...dates].sort((a, b) => a.getTime() - b.getTime());

  return (
    <Column>
      <Typography as="span" bold size="body_large">
        Selected Dates ({dates.length})
      </Typography>
      <Row wrap="wrap" style={{ gap: 10, marginTop: 24 }}>
        {sortedDates.map((date) => (
          <SelectedDatePill
            key={date.toISOString()}
            date={date}
            onRemove={() => onRemoveDate(date)}
          />
        ))}
      </Row>
    </Column>
  );
};
